import type { MaintenanceState, maintenanceToggleBodySchema } from '@flux/shared';
import type { z } from 'zod';
import { apiFetch } from '@/lib/api/client.js';

/**
 * `MaintenanceToggleBody` n'est pas exporté comme type par `@flux/shared`
 * (seul le schéma l'est) — dérivé ici par `z.infer`, comme
 * `FtpSettingsInput` dans `api-ftp.ts`.
 */
export type MaintenanceToggleBody = z.infer<typeof maintenanceToggleBodySchema>;

/**
 * Onglet Maintenance (`02` §12.6). La lecture réutilise
 * `useMaintenanceState()` (`features/settings/use-maintenance-state.ts`,
 * déjà écrit par la vague 5A) plutôt que de redéclarer le même `GET` — seule
 * la mutation de bascule est propre à cet onglet.
 */
export function toggleMaintenance(body: MaintenanceToggleBody): Promise<MaintenanceState> {
  return apiFetch<MaintenanceState>('/api/settings/maintenance/toggle', { method: 'POST', body });
}
